
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "@/hooks/use-toast";

export const useAdminAuth = () => {
  const navigate = useNavigate();
  const { user, session, isLoading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Aguardar o carregamento da autenticação antes de verificar admin
    if (authLoading) {
      return;
    }

    checkIsAdmin();
  }, [user, session, authLoading]);

  const checkIsAdmin = async () => {
    console.log("Verificando se usuário é admin:", user?.id);
    
    // Se ainda está carregando a auth, aguardar
    if (authLoading) {
      return;
    }

    // Se não há usuário ou sessão após carregar, redirecionar para auth
    if (!user || !session) {
      console.log("Usuário não autenticado, redirecionando para /auth");
      setIsAdmin(false);
      setLoading(false);
      navigate("/auth");
      return;
    }

    try {
      // Verificar se o usuário tem role de admin nos metadados
      const isUserAdmin = user.app_metadata?.role === "admin";
      console.log("Verificação admin:", { 
        userId: user.id, 
        app_metadata: user.app_metadata,
        role: user.app_metadata?.role,
        isAdmin: isUserAdmin 
      });
      
      setIsAdmin(isUserAdmin);

      if (!isUserAdmin) {
        console.log("Usuário não é admin, redirecionando");
        toast({
          title: "Acesso negado",
          description: "Você não tem permissão para acessar esta página",
          variant: "destructive",
        });
        navigate("/");
      }
    } catch (error) {
      console.error("Erro ao verificar status admin:", error);
      setIsAdmin(false);
      navigate("/");
    } finally {
      setLoading(false);
    }
  };

  return { isAdmin, loading: loading || authLoading };
};
